export const getAgentChatEntryButtonText = (record) =>
  record?.agentChatThreadId ? '查看创作' : '开始创作';

export const canStartAgentChatEntry = ({ record, seedType }) => {
  if (!record?.id) {
    return false;
  }
  if (record.agentChatThreadId) {
    return true;
  }
  return seedType !== 'hotPot' || record.status === '已入选';
};

export const buildAgentChatEntryPath = ({ record, seedType }) => {
  if (!record?.id || !seedType) {
    return '/agents-chat';
  }
  if (record.agentChatThreadId) {
    return `/agents-chat?threadId=${encodeURIComponent(record.agentChatThreadId)}`;
  }
  const search = new URLSearchParams({
    entry: seedType,
    recordId: record.id,
    title: record.title || '',
  });
  return `/agents-chat?${search.toString()}`;
};
